// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"17d9aa88","89":"a625846c","174":"7b7f5543","196":"0f4b97a6","227":"c8d28ef5","254":"85374f72","352":"faf12711","390":"4a59e2ed","426":"71f629f9","453":"abd36b29","462":"16ae0e62","545":"54f4b439","595":"c8dcf72a","741":"8473b45c","946":"4efbec44","975":"2825e1df"}[chunkId] + ".chunk.js";
};